/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseConversationMessages } from '../../models/api-response-conversation-messages';

export interface ExportConversation$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  reference: string;
}

export function exportConversation(http: HttpClient, rootUrl: string, params: ExportConversation$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseConversationMessages>> {
  const rb = new RequestBuilder(rootUrl, exportConversation.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('reference', params.reference, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseConversationMessages>;
    })
  );
}

exportConversation.PATH = '/v1/api/ui/conversation/{reference}/export';
